import * as React from 'react';
import Sidebar from './sidebar/sidebar';
import SidebarMobile from './topbar_with_navigation/sidebar_mobile/sidebar_mobile';
import TopbarWithNavigation from './topbar_with_navigation/topbar-with-navigation';
import Topbar from './topbar/topbar';
import {RouteComponentProps, withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import classNames from 'classnames';

export interface LayoutProps {
    isAuthenticated: boolean;
    isLoading: boolean;
    sidebar: any;
    customizer: any;
}

const mapStateToProps = (state) => {
    const stateProps = {
        isAuthenticated: state.app.getIsAuthenticated(),
        isLoading: state.app.getIsLoading(),
        sidebar: state.sidebar,
        customizer: state.customizer
    };
    return stateProps;
};

class Layout extends React.PureComponent<LayoutProps & RouteComponentProps<any>> {

    private get navigationComponent() {
        if (this.props.customizer.topNavigation) {
            return <TopbarWithNavigation/>

        } else {
            return <>
                <Topbar/>
                <Sidebar/>
            </>
        }
    }

    public render() {
        const layoutClass = classNames({
            layout: true,
            'layout--collapse': this.props.sidebar.collapse,
            'layout--top-navigation': this.props.customizer.topNavigation,
        });
        return this.props.isAuthenticated ? <div className={layoutClass}>
            {this.navigationComponent}
            <SidebarMobile/>
        </div> : null;
    }
}

export default withRouter(connect(mapStateToProps)(Layout));


// WEBPACK FOOTER //
// ./src/components/common/layout/layout.tsx